import React from 'react';

import BudgetTagsCell from '../budget_tags/BudgetTagsCell';

import NumberFormat from 'CommonComponents/LocalisedNumberFormat';

function ExpenseItemShow(props) {
    const showBudgetTags = !!props.showBudgetTags;
    const columnBasis = showBudgetTags ? 'tw-basis-2/12' : 'tw-basis-3/12';

    return (
        <div className="tw-flex tw-bg-[#f1f1f1]">
            <div className="tw-basis-12 tw-shrink-0 tw-flex tw-items-center tw-justify-center tw-p-3 tw-border-r-2 tw-bg-inherit"></div>
            {'template_divider' === props.type ? (
                <div className="tw-basis-full tw-p-3 tw-bg-inherit">{props.name}</div>
            ) : (
                <>
                    <div className="tw-basis-full tw-flex tw-items-center">
                        <div className={`${columnBasis} tw-p-3 tw-border-r-2 tw-bg-inherit`}>{props.name}</div>
                        <div className={`${columnBasis} tw-p-3 tw-border-r-2 tw-bg-inherit`}>{props.description}</div>
                        <div className={`${columnBasis} tw-p-3 tw-border-r-2 tw-bg-inherit`}>
                            <NumberFormat value={props.price} displayType={'text'} thousandSeparator={true} decimalScale={0} />
                        </div>
                        <div className={`${showBudgetTags ? 'tw-basis-4/12' : 'tw-basis-6/12'} tw-grid tw-grid-cols-2`}>
                            {props.maxQuantitiesColumns &&
                                [...Array(props.maxQuantitiesColumns).keys()].map((index) => (
                                    <div className="tw-p-3 tw-border-r-2 tw-bg-inherit" key={index}>
                                        {props.amount && props.amount[index] && props.amount[index].name}
                                    </div>
                                ))}
                        </div>
                        {showBudgetTags && (
                            <div className="tw-basis-2/12 tw-p-3 tw-border-r-2 tw-bg-inherit">
                                <BudgetTagsCell cell={props.budgetTags} onOpen={() => props.onOpenBudgetTags(props.expenseId, props.name)} />
                            </div>
                        )}
                    </div>
                    <div className="tw-basis-12 tw-shrink-0 tw-flex tw-items-center tw-justify-center tw-p-3 tw-bg-inherit"></div>
                </>
            )}
        </div>
    );
}

export default React.memo(ExpenseItemShow);
